import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useRouteHook } from '@shared/hooks';
import { RoutePaths } from '@shared/utils';
import { Footer } from '@widgets';
import { Button, Text } from '@shared/widgets';
import errorImg from '@assets/images/error-page.png';

export const ErrorPage = () => {
  const { pathname } = useLocation();
  const { navigate } = useRouteHook();

  const { t } = useTranslation('error');

  useEffect(() => {
    if (pathname === RoutePaths.signup.onNavigate() || pathname === RoutePaths.success.onNavigate()) navigate(RoutePaths.dashboard.onNavigate());
  }, [pathname]);

  return (
    <>
      <main className='mt-[100px] flex flex-auto flex-col py-12 text-center'>
        <section className='m-auto'>
          <img className='mb-6 max-w-[510px]' src={errorImg} alt='error' />
          <Text className='mb-6 font-[Prata]' size='5xl'>
            {t('title')}
          </Text>
          <Text weight='light' size='lg'>
            {t('description')}
          </Text>
          <Button className='mt-12' color='primary' to={RoutePaths.dashboard.onNavigate()}>
            {t('buttons.goBack')}
          </Button>
        </section>
      </main>
      <Footer />
    </>
  );
};
